// extracted by mini-css-extract-plugin
module.exports = {"pintxo-badge":"Badge_pintxo-badge__QkXev","pintxo-badge-wrapper__badge__value":"Badge_pintxo-badge-wrapper__badge__value__UyIT_"};